//#region src/components/typography/shared.ts
const getColor = (color, highContrast = false) => {
	if (color === "white" || color === "currentColor") return color;
	return highContrast ? `var(--mantine-color-${color}-9)` : `var(--mantine-color-${color}-7)`;
};

//#endregion
export { getColor };